export default {"src":"/_next/static/media/Star-Vector.570b8b2a.svg","height":20,"width":20};